import { render, staticRenderFns } from "./PendenciasTelaPagamento.vue?vue&type=template&id=72fc041a&"
import script from "./PendenciasTelaPagamento.vue?vue&type=script&lang=js&"
export * from "./PendenciasTelaPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports